import getTableComponent from '../../getTableComponent';
import schemas from 'src/products/admin/redux/tables/schemas';

export default getTableComponent(schemas.signups);
